'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './reports.routes';

export class ReportsComponent {
  constructor($uibModal, SettingsService) {
    'ngInject';
    this.$uibModal = $uibModal;

    SettingsService.getByName({name: 'reports'}, settings => {
      this.reports = settings.data;
    })
  }

  openReportFilterModal(report) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'reportFilterModal',
      resolve: {
        config: function() {
          return report
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduu.reports', [uiRouter])
  .config(routes)
  .component('reports', {
    template: require('./reports.html'),
    controller: ReportsComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/reports/reports.component.js